export const useMediaQuery = query => {
  const mediaMatch = window.matchMedia(query);
  return mediaMatch.matches;
};
